/** @jsxImportSource @emotion/react */
import React from 'react'
import {CycleForm, CyclePreview} from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/NewCycleContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageCycle } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageCycle]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <CycleForm />
        </div>
        <div css={styles.right}>
          <CyclePreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
